import { render } from "./ButtonRegular.vue?vue&type=template&id=27f92197&ts=true"
import script from "./ButtonRegular.vue?vue&type=script&lang=ts"
export * from "./ButtonRegular.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__